<template>
    <div class="sidebar" v-on-clickaway="hideMobile">
        <slot></slot>
    </div>
</template>

<script>
import { mixin as ClickawayMixin } from 'vue-clickaway'

export default {
  name: 'Sidebar',
  mixins: [ClickawayMixin],
  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.addClasses()
  },
  methods: {
    hideMobile() {
      if (document.body.classList.contains('sidebar-show')) {
        document.body.classList.toggle('sidebar-show')
      }
    },
    addClasses() {
      if (this.fixed) {
        document.body.classList.add('sidebar-fixed')
      } else {
        document.body.classList.remove('sidebar-fixed')
      }
      return this.fixed
    }
  }
}
</script>

<style scoped>

.sidebar {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
